/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Activity_Achievementalt1Inputs */

const id_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const ms_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const da_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement`)
};

const de_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaft`)
};

const en_us2_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement`)
};

const es_es2_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logro`)
};

const es_mx2_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logro`)
};

const fil_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement`)
};

const fr_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const it_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultato`)
};

const hu_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmény`)
};

const nl_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestatie`)
};

const no_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjon`)
};

const pl_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięcie`)
};

const pt_br2_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquista`)
};

const pt_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquista`)
};

const ro_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizare`)
};

const fi_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutus`)
};

const sv_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestation`)
};

const vi_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích`)
};

const tr_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarım`)
};

const cs_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěch`)
};

const bg_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Постижение`)
};

const ru_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достижение`)
};

const uk_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнення`)
};

const ar_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنجاز`)
};

const hi_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धि`)
};

const th_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสำเร็จ`)
};

const ja_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績`)
};

const zh_cn2_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const zh_hant1_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const ko_profile_activity_achievementalt1 = /** @type {(inputs: Profile_Activity_Achievementalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제`)
};

/**
* | output |
* | --- |
* | "Achievement" |
*
* @param {Profile_Activity_Achievementalt1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_achievementalt1 = /** @type {((inputs?: Profile_Activity_Achievementalt1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_Achievementalt1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_achievementalt1(inputs)
	if (locale === "ms") return ms_profile_activity_achievementalt1(inputs)
	if (locale === "da") return da_profile_activity_achievementalt1(inputs)
	if (locale === "de") return de_profile_activity_achievementalt1(inputs)
	if (locale === "en-US") return en_us2_profile_activity_achievementalt1(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_achievementalt1(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_achievementalt1(inputs)
	if (locale === "fil") return fil_profile_activity_achievementalt1(inputs)
	if (locale === "fr") return fr_profile_activity_achievementalt1(inputs)
	if (locale === "it") return it_profile_activity_achievementalt1(inputs)
	if (locale === "hu") return hu_profile_activity_achievementalt1(inputs)
	if (locale === "nl") return nl_profile_activity_achievementalt1(inputs)
	if (locale === "no") return no_profile_activity_achievementalt1(inputs)
	if (locale === "pl") return pl_profile_activity_achievementalt1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_achievementalt1(inputs)
	if (locale === "pt") return pt_profile_activity_achievementalt1(inputs)
	if (locale === "ro") return ro_profile_activity_achievementalt1(inputs)
	if (locale === "fi") return fi_profile_activity_achievementalt1(inputs)
	if (locale === "sv") return sv_profile_activity_achievementalt1(inputs)
	if (locale === "vi") return vi_profile_activity_achievementalt1(inputs)
	if (locale === "tr") return tr_profile_activity_achievementalt1(inputs)
	if (locale === "cs") return cs_profile_activity_achievementalt1(inputs)
	if (locale === "bg") return bg_profile_activity_achievementalt1(inputs)
	if (locale === "ru") return ru_profile_activity_achievementalt1(inputs)
	if (locale === "uk") return uk_profile_activity_achievementalt1(inputs)
	if (locale === "ar") return ar_profile_activity_achievementalt1(inputs)
	if (locale === "hi") return hi_profile_activity_achievementalt1(inputs)
	if (locale === "th") return th_profile_activity_achievementalt1(inputs)
	if (locale === "ja") return ja_profile_activity_achievementalt1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_achievementalt1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_achievementalt1(inputs)
	return ko_profile_activity_achievementalt1(inputs)
});
export { profile_activity_achievementalt1 as "profile.activity.achievementAlt" }